var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35351 16.3532L0.944345 17.3332L1.92435 12.924C1.27896 11.7168 0.942284 10.3687 0.944345 8.99984C0.944345 4.39734 4.67518 0.666504 9.27768 0.666504C13.8802 0.666504 17.611 4.39734 17.611 8.99984C17.611 13.6023 13.8802 17.3332 9.27768 17.3332C7.90881 17.3352 6.56069 16.9986 5.35351 16.3532ZM5.59518 14.5923L6.13935 14.884C7.1048 15.4 8.18301 15.6688 9.27768 15.6665C10.5962 15.6665 11.8852 15.2755 12.9815 14.543C14.0778 13.8104 14.9323 12.7692 15.4369 11.5511C15.9415 10.3329 16.0735 8.99244 15.8162 7.69924C15.559 6.40603 14.9241 5.21814 13.9917 4.28579C13.0594 3.35344 11.8715 2.7185 10.5783 2.46127C9.28507 2.20403 7.94463 2.33606 6.72646 2.84064C5.50828 3.34522 4.46709 4.19971 3.73455 5.29604C3.00201 6.39236 2.61101 7.6813 2.61101 8.99984C2.61101 10.1123 2.88185 11.1807 3.39435 12.1382L3.68518 12.6823L3.13935 15.1382L5.59518 14.5923Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenario);
export default __webpack_public_path__ + "static/media/scenario.31c105a72943c3c5404ae9ec79ab77b6.svg";
export { ForwardRef as ReactComponent };